import PropTypes from 'prop-types';
import { X } from 'lucide-react';
import { FROZEN, isWeekend } from './tableChrome';
import { dayLabel } from './mediaPlanningView';

const LABEL = `${FROZEN} z-20 whitespace-nowrap border-b border-gray-100 px-4 py-1.5 text-left`;

/**
 * One timeline row: a label (brand name or "Calendario comercial") + colored
 * bars over the days each promo runs. Used by the cross-brand promo calendar.
 */
export default function PromoTimelineRow({ label, promos, days, today, onDelete, tone }) {
  const bar = tone === 'sky' ? 'bg-sky-200' : 'bg-fuchsia-200';
  const text = tone === 'sky' ? 'text-sky-900' : 'text-fuchsia-900';
  const promoOn = (iso) => promos.find((p) => p.from_date <= iso && iso <= p.to_date);

  return (
    <tr className="group">
      <th className={`${LABEL} font-medium text-gray-700`}>
        <span className="block max-w-[190px] truncate">{label}</span>
      </th>
      {days.map((d) => {
        const p = promoOn(d.date);
        const start = p && p.from_date === d.date;
        const end = p && p.to_date === d.date;
        const weekend = isWeekend(dayLabel(d.date).weekday) ? 'bg-gray-50/60' : '';
        return (
          <td
            key={d.date}
            className={`relative border-b border-gray-100 px-0 py-1.5 ${d.date === today ? 'bg-indigo-50' : weekend}`}
          >
            {p && (
              <div
                className={`h-4 ${bar} ${start ? 'ml-1 rounded-l-full' : ''} ${end ? 'mr-1 rounded-r-full' : ''}`}
                title={`${p.name} · ${p.from_date} → ${p.to_date}`}
              />
            )}
            {start && (
              <span className={`pointer-events-none absolute left-2 top-1/2 z-10 -translate-y-1/2 whitespace-nowrap text-[11px] font-medium ${text}`}>
                {p.name}
              </span>
            )}
            {start && onDelete && (
              <button
                type="button"
                onClick={() => onDelete(p)}
                className="absolute -right-0.5 -top-0.5 z-20 hidden rounded-full bg-white text-fuchsia-500 hover:text-fuchsia-700 group-hover:block"
                aria-label={`Quitar promo ${p.name}`}
              >
                <X size={11} />
              </button>
            )}
          </td>
        );
      })}
    </tr>
  );
}

PromoTimelineRow.propTypes = {
  label: PropTypes.node.isRequired,
  promos: PropTypes.array,
  days: PropTypes.array,
  today: PropTypes.string,
  onDelete: PropTypes.func,
  tone: PropTypes.oneOf(['fuchsia', 'sky']),
};
